import { rootDomain } from '@stores/root';

export const cartDomain = rootDomain.createDomain('cart');
